// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fdoeT","questions":"styles_questions__2xDcz","footer":"styles_footer__30rkL"};